module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"setBudgetCard.title":"Budget","setBudgetCard.subtitle":"Setting a budget is an important way to manage your overall cloud spend."}}')
  delete Component.options._Ctor
}
